import styled from 'styled-components';

export {
  Title,
  Paragraph,
  Form,
  SubmitButton,
  StatusMessage,
} from '../../styles';

export const OptionItem = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  margin: 0;
  border-radius: 12px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
  border: 1px solid
    ${({ theme, $selected }) =>
      $selected
        ? theme.colors.porterBlue500
        : theme.colors.semantic.border.default};
  box-shadow: ${({ theme, $selected }) =>
    $selected ? theme.colors.semantic.shadow.sm : 'none'};

  &:focus-within {
    outline: 2px solid ${({ theme }) => theme.colors.porterBlue500};
    outline-offset: 2px;
  }

  input {
    margin: 2px 0 0;
    width: 20px;
    height: 20px;
    accent-color: ${({ theme }) => theme.colors.porterBlue500};
  }

  span {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
  }

  strong {
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.semantic.text.primary};
  }

  small {
    font-size: 14px;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
  }
`;
